import { Text, TokenTextAppearance, styled } from '@volkswagen-onehub/components-core';
import { Checkmark } from '@volkswagen-onehub/icons-core';
import React from 'react';

type ContainerProps = {
  isLastItem: boolean;
}

const ContainerWrapper = styled.div<ContainerProps>`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  -webkit-box-align: baseline;
  align-items: baseline;
  flex-shrink: 1;
  padding: 0px;
  flex-grow: 1;
  margin-bottom: ${props => props.isLastItem ? '0px' : '12px'};
  svg {
    margin-right: 16px;
  }
`;
interface EquipmentTitleProps {
  title: string;
  isLastItem: boolean;
}

export const EquipmentTitle = (props: EquipmentTitleProps) => {
  const { title, isLastItem } = props;
  return (
    <ContainerWrapper isLastItem={isLastItem}>
      <div>
        <Checkmark variant="small" />
      </div>
      <Text appearance={TokenTextAppearance.copy200}>{title}</Text>
    </ContainerWrapper>
  );
};
